import { db } from "../../config/firebaseconfig"

export default function fetchGroupUAs (user, assessmentId, actions, selectedGroupUA, view, subtestId, districts, selectedStudent) {
  actions.fetching()
  // super admin might eventually have performance issues. Might need to change to get()
  // If Super Administrator, get all of the groupUAs.
  if (user.role === 'Super Administrator') {
    return db.collection('groupUA').where('groupType', '==', 'District').get()
      .then((querySnapshot) => {
        let groupUAs = {}
        querySnapshot.forEach((doc) => {
          groupUAs[doc.id] = doc.data()
        })
        actions.success(groupUAs)
        //actions.setIndicator(selectedGroupUA)
      })
      .catch(err => actions.error(err))
  } else {
    // If not Super Administrator, query db based on role.
    let query
    if (user.role === 'District Admin') {
      query = {key: 'district', term: user.schoolDistrict}
    } else if (user.role === 'School Admin') {
      query = {key: 'school', term: user.school}
    } else if (user.role === 'Teacher') {
      query = {key: 'teacher', term: user.id}
    }
    return db.collection('groupUA').where(query.key, '==', query.term).get()
      .then((querySnapshot) => {
        let groupUAs = {}
        querySnapshot.forEach((doc) => {
          groupUAs[doc.id] = doc.data()
        })
        actions.success(groupUAs)
        //actions.setIndicator(selectedGroupUA)
      })
      .catch(err => actions.error(err))
    }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/fetchGroupUAs.js